exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#InviteCard[data-v-167dc27e]{padding:20px}#imgecard[data-v-167dc27e]{display:block;width:100%}.Label[data-v-167dc27e]{font-size:16px;padding:5px 0}.text[data-v-167dc27e]{font-size:13px;padding-bottom:20px}.u-btn[data-v-167dc27e]{display:block;text-align:center;padding:10px;color:#fff;margin:30px auto 10px;background-color:#00acff;border-radius:2px}.u-btn[data-v-167dc27e]:active{background-color:#f44336}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-167dc27e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/InviteCard.vue
// module id = 425
// module chunks = 0